<template>
    <div class="flats-crm-items-container flats-items-list" v-if="flatsItems != null">
        <div class="flats-empty-msg" v-if="flatsEmptyMsg"><p>По данному запросу квартир в продаже не найдено</p></div>
        <div class="flat-cards-items-list-info" v-if="!flatsEmptyMsg && !mobileView">
            <ul>
                <div class="left">
                    <li><p>{{flatsPage.flats_cards_info.flat_plan_name}}</p></li>
                </div>
                <div class="center">
                    <li><p>{{flatsPage.flats_cards_info.flat_rooms}}</p></li>
                    <li><p>{{flatsPage.flats_cards_info.flat_floor}}</p></li>
                    <li><p>{{flatsPage.flats_cards_info.flat_size}}</p></li>
                    <li v-if="saleItem.project_stie_shablon_price_flats_init == 'true'"><p>{{flatsPage.flats_cards_info.flat_price}} <span>м²</span></p></li>
                    <li><p>{{flatsPage.flats_cards_info.flat_flat_number}}</p></li>
                    <li><p>{{flatsPage.flats_cards_info.flat_bloom}}</p></li>
                </div>
                <div class="right" v-if="saleFilterParams.project_stie_flats_filter_init == 'true'">
                    <li><p>{{flatsPage.flats_cards_info.flat_you_can_name}}</p></li>
                </div>
            </ul>
        </div>
        <div class="flats-items-list-loop" v-if="!flatsEmptyMsg">
            <div class="flat-item" v-for="item in flatsItems" :key="item.id">
                <a href="#" @click.prevent="openCrmFlatModal(item)">
                    <div class="item-default item-img" v-if="item != null && item.id != null">
                        <div class="img-in" v-if="item.images.length > 0">
                            <img :src="'https://bazis-online.kz/crmc/rest/prices/getImage?imageId=' + pic.id" alt="" v-for="pic in item.images" v-if="pic.typeCode == '1'">
                        </div>
                        <div class="card-table-list-img">
                            <img :src="'https://bazis-online.kz/crmc/rest/prices/getImage?imageId=' + pic.id" alt="" v-for="pic in item.images" v-if="pic.typeCode == '1'">
                        </div>
                    </div>
                    <div class="item-info">
                        <ul>
                            <li>
                                <p v-if="mobileView">{{flatsPage.flats_cards_info.flat_rooms}}</p>
                                {{item.rooms}}
                            </li>
                            <li>
                                <p v-if="mobileView">{{flatsPage.flats_cards_info.flat_floor}}</p>
                                {{item.floor}}
                            </li>
                            <li>
                                <p v-if="mobileView">{{flatsPage.flats_cards_info.flat_size}}</p>
                                {{item.area}} <span>м²</span>
                            </li>
                            <li class="price">
                                <p v-if="mobileView">{{flatsPage.flats_cards_info.flat_price}} <span>тг. м²</span></p>
                                <strong v-if="saleItem.project_stie_shablon_price_flats_init == 'true' && item.showPricesOnSaleSite == true"><span>от</span> {{getNumber(item.meterPrice)}} <span v-if="!mobileView">тг.</span></strong>
                            </li>
                            <li>
                                <p v-if="mobileView">{{flatsPage.flats_cards_info.flat_flat_number}}</p>
                                {{item.number}}
                            </li>
                            <li>
                                

                                <p v-if="mobileView && item.complexCode != 'SOH'">{{flatsPage.flats_cards_info.flat_bloom}}</p>
                                <p v-if="mobileView && item.complexCode == 'SOH'">{{flatsPage.flats_cards_info.flat_kvartal}}</p>

                                <div class="blockname" v-if="item.complexCode != 'SOH'">
                                    {{getNumbersOfString(item.blockName)}}
                                </div>
                                <div class="blockname" v-if="item.complexCode == 'SOH'">
                                    {{getNumbersOfBlockSoho(item.blockName)}}
                                </div>
                            </li>
                        </ul>
                    </div>
                    <div class="item-btns" v-if="saleFilterParams.project_stie_flats_filter_init == 'true'">
                        <div v-if="item.complexCode == 'ALF' || item.complexCode == 'EST' || item.complexCode == 'JAZ' || item.complexCode == 'ОRI' || item.complexCode == 'PRV' || item.complexCode == 'SOH'">
                            <a 
                                :href="'https://lk01.bazis.kz/?apartment_id=' + item.id + '&method=book'" class="bron" target="_blank" 
                                v-if="item.isApartmentReserved"
                                >{{flatsPage.flats_cards_info.flat_btn_book_name}}
                            </a>
                            <span v-else class="btn-off bron-off">{{flatsPage.flats_cards_info.flat_btn_book_name}}</span>
                            <a 
                                :href="'https://lk01.bazis.kz/?apartment_id=' + item.id + '&method=by'" class="by" target="_blank" 
                                v-if="item.hasJointVentureAgreement"
                                >{{flatsPage.flats_cards_info.flat_btn_by_name}}
                            </a>
                            <span v-else class="btn-off by-off">{{flatsPage.flats_cards_info.flat_btn_by_name}}</span>
                        </div>
                        <div v-else>
                            <a 
                                :href="'https://lk01.bazis.kz/?apartment_id=' + item.id + '&method=book'" class="bron" target="_blank" 
                                v-if="checkConfirmPurchase('book', item.complexCode, item.blockName)"
                                >{{flatsPage.flats_cards_info.flat_btn_book_name}}
                            </a>
                            <span v-else class="btn-off bron-off">{{flatsPage.flats_cards_info.flat_btn_book_name}}</span>
                            <a 
                            :href="'https://lk01.bazis.kz/?apartment_id=' + item.id + '&method=by'" class="by" target="_blank" 
                                v-if="checkConfirmPurchase('by', item.complexCode, item.blockName)"
                                >{{flatsPage.flats_cards_info.flat_btn_by_name}}
                            </a>
                            <span v-else class="btn-off by-off">{{flatsPage.flats_cards_info.flat_btn_by_name}}</span>
                        </div>
                    </div>
                </a>
               
                <!-- <a href="#" class="getPrice" @click.prevent="openFormModal(true)">ЗАПРОСИТЬ ЦЕНУ</a> -->
            </div>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex'
    export default {
        name: 'flats-items-list',
        props: ['mobileView'],
        components: {
        },
        data () {
            return {
                projectHost: window.host,
            }
        },
        methods: {
            getNumbersOfString(str) {
                return str.replace(/[^0-9]+/g, "");
            },
            getNumbersOfBlock(str) { 
                var parseStr = str.split(',')[0];
                return parseStr.replace(/[^0-9]+/g, "");
            },
            getNumbersOfBlockDiscovery(str) { 
                var parseStr = str.split(',')[0];
                return parseStr.replace('Пятно', '');
            },
            getNumbersOfBlockSoho(str) {
                var parseStr = str.split(',')[0];
                return parseStr.replace('Квартал', '').replace(/ /g, '');
            },
            getBlockPartSOH(str) {
                var blockPart;
                blockPart = str.split(',')[1];
                blockPart = blockPart.replace('Блок', '');
                blockPart = blockPart.replace(/ /g, '');
                return blockPart;
            },
            getNumber(n) {
                return String(n).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1.")
            },
            openCrmFlatModal(arr) {
                this.$store.commit('modalData', arr);
                setTimeout(() => {
                    this.$modal.show('sales_land_flat_card_crm_modal');
                }, 300);
            },
            getPriceForm() {

            },
            startLoader() {
                this.$parent.$refs.topProgress.start();
            },
            openFormModal(param) {
                this.$store.commit('Open_Form_Modal', param);
            },
            checkConfirmPurchase(param, code, blockName) {
                // console.log(param, code, blockName)
                var blockNameBparse = blockName;
                if (code != 'SOH') {
                    blockName = this.getNumbersOfString(blockName);
                } else if (code == 'SOH') {
                    blockName = this.getNumbersOfBlockSoho(blockName);
                } 
                // console.log(blockName, blockNameBparse)

                if (param == 'book') {
                    if (code == 'AKV') { // Настройка кнопок Акварель
                        if (blockName == '25' || blockName == '26' || blockName == '27' || blockName == '28') {
                            return true;
                        } else {
                            return false;
                        }
                    } 
                    // ASTANA
                    else if (code == 'SOH') { // Настройка кнопок Soho
                        // console.log(blockName, this.blockPart)
                        if (blockName == '2A') {
                            if (this.getBlockPartSOH(blockNameBparse) == 'А1' || this.getBlockPartSOH(blockNameBparse) == 'А2' || this.getBlockPartSOH(blockNameBparse) == 'А3' || this.getBlockPartSOH(blockNameBparse) == 'А4' || this.getBlockPartSOH(blockNameBparse) == 'А5' || this.getBlockPartSOH(blockNameBparse) == 'А6' || this.getBlockPartSOH(blockNameBparse) == 'А7' || this.getBlockPartSOH(blockNameBparse) == 'А8' || this.getBlockPartSOH(blockNameBparse) == 'А9') {
                                return true;
                            } else {
                                return false;
                            }
                        } else if (blockName == '2А') {
                            if (this.getBlockPartSOH(blockNameBparse) == 'А1' || this.getBlockPartSOH(blockNameBparse) == 'А2' || this.getBlockPartSOH(blockNameBparse) == 'А3' || this.getBlockPartSOH(blockNameBparse) == 'А4' || this.getBlockPartSOH(blockNameBparse) == 'А5' || this.getBlockPartSOH(blockNameBparse) == 'А6' || this.getBlockPartSOH(blockNameBparse) == 'А7' || this.getBlockPartSOH(blockNameBparse) == 'А8' || this.getBlockPartSOH(blockNameBparse) == 'А9') {
                                return true;
                            } else {
                                return false;
                            }
                        }
                    }
                } else if (param == 'by') {
                    // ALMATY
                    if (code == 'AKV') { // Настройка кнопок Акварель
                        if (blockName == '25' || blockName == '26' || blockName == '27' || blockName == '28') {
                            return true;
                        } else {
                            return false;
                        }
                    } 
                    // ASTANA
                    else if (code == 'SOH') { // Настройка кнопок Soho
                        if (blockName == '2A') {
                            if (this.getBlockPartSOH(blockNameBparse) == 'А1' || this.getBlockPartSOH(blockNameBparse) == 'А2' || this.getBlockPartSOH(blockNameBparse) == 'А3' || this.getBlockPartSOH(blockNameBparse) == 'А4' || this.getBlockPartSOH(blockNameBparse) == 'А5' || this.getBlockPartSOH(blockNameBparse) == 'А6' || this.getBlockPartSOH(blockNameBparse) == 'А7' || this.getBlockPartSOH(blockNameBparse) == 'А8' || this.getBlockPartSOH(blockNameBparse) == 'А9') {
                                return true;
                            } else {
                                return false;
                            }
                        } else if (blockName == '2А') {
                            if (this.getBlockPartSOH(blockNameBparse) == 'А1' || this.getBlockPartSOH(blockNameBparse) == 'А2' || this.getBlockPartSOH(blockNameBparse) == 'А3' || this.getBlockPartSOH(blockNameBparse) == 'А4' || this.getBlockPartSOH(blockNameBparse) == 'А5' || this.getBlockPartSOH(blockNameBparse) == 'А6' || this.getBlockPartSOH(blockNameBparse) == 'А7' || this.getBlockPartSOH(blockNameBparse) == 'А8' || this.getBlockPartSOH(blockNameBparse) == 'А9') {
                                return true;
                            } else {
                                return false;
                            }
                        }
                    } 
                } else {
                    return false;
                }
            },
        },
        computed: mapGetters({
            flatsPage: 'loadSalesFlatsPageData',
            salesCard: 'loadSalesCardContent',
            salesCardPage: 'loadSalesCardPage',
            saleItem: 'loadSaleCardItem',
            saleFilterParams: 'loadSalesFilterCardParams',
            flatsItems: 'loadFlatsItems',
            flatsEmptyMsg: 'loadFlatsEmptyMsg',
        }),
        beforeCreate() {
        },
        created () {
        },
        mounted () {
        }
    }
</script>

<style lang="scss">
    @import '@/styles/components/flats-crm/flats-crm-items-list.scss';
    @import '@/styles/components/flats-crm/flats-crm-items-main.scss';
    @import '@/styles/components/flats-crm/respond/flats-crm-items-list-respond.scss';
    @import '@/styles/components/flats-crm/respond/flats-crm-items-main-respond.scss';
    // @import '@/styles/components/flats-page/respond/flats-item-respond.scss';
</style>